import { COMMUNITY_RULES_LINK, SCORING_ROWS } from "./data/DiscordPageData";

export default function DiscordScoring() {
  return (
    <>
      {/* ── SCORING ──────────────────────────────────────────────── */}
      <section className="dsc-section" id="scoring">
        <div className="dsc-eyebrow">Quantum Points</div>
        <h2 className="dsc-h2">
          Everything you do <span className="hi">counts</span>
        </h2>
        <p className="dsc-section-sub dsc-wide">
          Quantum points are the community's currency. They come from real
          work across eight sources, they are capped per day so volume can't
          beat quality, and they decide your rank.
        </p>

        <div className="dsc-table-wrap">
          <table className="dsc-table">
            <thead>
              <tr>
                <th>Activity</th>
                <th className="dsc-num">Points</th>
                <th>How it counts</th>
              </tr>
            </thead>
            <tbody>
              {SCORING_ROWS.map((r) => (
                <tr key={r.activity}>
                  <td className="dsc-td-act">{r.activity}</td>
                  <td className="dsc-num">
                    <span className="dsc-pts">{r.points}</span>
                  </td>
                  <td className="dsc-td-note">{r.note}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="dsc-note">
          Medals earn points too, and every cap above is a daily ceiling, so
          chatting or committing past it is still visible but scores nothing.{" "}
          <a
            href={COMMUNITY_RULES_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="dsc-inline-link"
          >
            Read the full rules ↗
          </a>
        </p>
      </section>
    </>
  );
}
